import { pipe, prop } from 'ramda';

import { nonEmptyIntersection } from 'utils/functions';
import { permissions } from 'constants/user';
import groupProductFamilies from 'constants/groupProductFamilies';
import groupContractCodes from 'constants/groupContractCodes';
import { isUserEurostarAgent } from 'utils/booking';
import { SR_GENERATE_OFFICE, SR_PROCESS_OFFICE } from 'constants/offices';

const User = {
  isStation: (user) => user.offices.some((office) => office.isStation),
  canEditPassengers: pipe(prop('permissions'), nonEmptyIntersection([permissions.EXTERNAL_NAME_CHANGE, permissions.INTERNAL_NAME_CHANGE])),
  canHaveGroupBookings: (user) =>
    isUserEurostarAgent(user)
      ? !!user.productFamilies.find(({ code }) => groupProductFamilies.includes(code))
      : !!user.productFamilies.find(({ code }) => groupContractCodes.includes(code)),
  canHaveStandardBookings: (user) => !!user.productFamilies.find((productFamily) => !groupProductFamilies.includes(productFamily.code)),
  paymentLocation: ({ offices }) => {
    if (offices && offices.length > 0) {
      return offices.find((o) => o.defaultPaymentLocation);
    }

    return null;
  },
  canOverrideFees: pipe(prop('permissions'), nonEmptyIntersection([permissions.EXTERNAL_WAIVE_FEES, permissions.INTERNAL_WAIVE_FEES])),
  canOverrideRules: pipe(
    prop('permissions'),
    nonEmptyIntersection([permissions.EXTERNAL_OVERRIDE_AFTERSALES_RULES, permissions.INTERNAL_OVERRIDE_AFTERSALES_RULES])
  ),
  canManageVouchers: ({ allowedVoucherCreationTypes, canRetrieveVouchers }) => !!allowedVoucherCreationTypes?.length || canRetrieveVouchers,
  canCreateVouchers: ({ allowedVoucherCreationTypes }) => !!allowedVoucherCreationTypes?.length,
  canManageGenerateBulkVouchers: ({ offices }) => {
    if (offices && offices.length > 0) {
      return offices.some((o) => o.name === SR_GENERATE_OFFICE);
    }

    return false;
  },
  canManageProcessBulkVouchers: ({ offices }) => {
    if (offices && offices.length > 0) {
      return offices.some((o) => o.name === SR_PROCESS_OFFICE);
    }

    return false;
  }
};

export default User;
